import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import ReactTable from 'react-table';
// import 'react-table/react-table.css';

export default function ExecutionHistoryTable() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get('/api/alerts/system/history');
        setHistory(response.data);
      } catch (error) {
        console.error('Error fetching history:', error);
        toast.error('Failed to load history');
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []); // Empty dependency array means this runs once on mount

  if (loading) {
    return <div className="text-center py-8">Loading history...</div>;
  }

  return (
    <div className="bg-white shadow rounded">
      <div className="p-4">
        <div className="overflow-x-auto">
          <ReactTable
            data={history}
            columns={[
              {
                Header: 'Alert ID',
                accessor: 'alert_id',
                Cell: ({ value }) => <span className="text-sm font-mono">{value}</span>
              },
              {
                Header: 'Run Start',
                accessor: 'run_start_time',
                Cell: ({ value }) => {
                  if (value) {
                    return <span className="text-sm">{new Date(value).toLocaleString()}</span>;
                  }
                  return <span className="text-gray-400">N/A</span>;
                }
              },
              {
                Header: 'Run End',
                accessor: 'run_end_time',
                Cell: ({ value }) => {
                  if (value) {
                    return <span className="text-sm">{new Date(value).toLocaleString()}</span>;
                  }
                  return <span className="text-gray-400">N/A</span>;
                }
              },
              {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ value }) => (
                  <span className={`px-2 py-1 rounded text-xs font-medium ${
                    value === 'success' ? 'bg-green-100 text-green-800' : 
                    value === 'failure' ? 'bg-red-100 text-red-800' : 
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {value?.toUpperCase() || 'UNKNOWN'}
                  </span>
                )
              },
              {
                Header: 'Affected Nodes',
                accessor: 'affected_nodes_count',
                Cell: ({ value }) => <span className="text-sm font-mono">{value}</span>
              },
              {
                Header: 'Execution Time (s)',
                accessor: 'execution_time_seconds',
                Cell: ({ value }) => <span className="text-sm font-mono">{value}</span>
              },
              {
                Header: 'Error Message',
                accessor: 'error_message',
                Cell: ({ value }) => {
                  if (value) {
                    return (
                      <div className="max-w-xs truncate" title={value}>
                        <span className="text-red-600">{value}</span>
                      </div>
                    );
                  }
                  return <span className="text-gray-400">None</span>;
                }
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
      </div>
    </div>
  );
} 
